module.exports = __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/scientific_inquiry2-97c2d794e8ad678653840c42836185d4.svg";